import { observer } from 'mobx-react-lite'
import { useMemo } from 'react'
import { Table } from 'shared/ui/TableNew'
import { type PerformanceComparisonTableStore } from 'pages/analytics/pages/performance/store/performanceAnalyticsPageStore'
import { getColumns } from './getColumns'

interface IPerformanceComparisonTableProps {
  store: PerformanceComparisonTableStore
}

export const PerformanceComparisonTable = observer(
  ({ store }: IPerformanceComparisonTableProps) => {
    const { tableStore, comparisonRows, breakdownFilterType } = store

    const columns = useMemo(() => getColumns(breakdownFilterType), [breakdownFilterType])

    return (
      <Table
        ariaLabel={'PerformanceComparisonTable'}
        store={tableStore}
        columns={columns}
        rows={comparisonRows}
        hidePagination={true}
        emptyStateProps={{
          text: 'No comparison data found',
          noIcon: true,
        }}
        scrollbarProps={{
          autoHeight: true,
          height: 'auto',
          autoHeightMax: 600,
        }}
      />
    )
  }
)
